import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

const TransactionAccessAddEditModal = ({ isOpen, onClose, selectedItem, onSave }) => {
  const [isFullAccess, setIsFullAccess] = useState(false);

  useEffect(() => {
    if (isOpen && selectedItem) {
      setIsFullAccess(!!selectedItem.isFullTransactionAccess);
    }
  }, [selectedItem, isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 overflow-auto">
      <div className="bg-white w-full md:w-[500px] rounded-lg shadow-xl flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b">
          <h2 className="text-xl font-bold text-gray-800">Update Transaction Access</h2>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer text-gray-500 hover:text-gray-700 transition-colors">
            <CloseIcon fontSize="medium" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-6">
          <div>
            <label className="block text-sm font-semibold text-gray-500 uppercase mb-2">Access Type Information</label>
            <input
              value={selectedItem?.description || ""}
              disabled
              className="w-full p-2 border border-gray-300 rounded bg-gray-100 text-gray-600 italic"
            />
          </div>

          <div className="border border-gray-200 rounded-lg bg-gray-50 p-4">
            <h3 className="text-sm font-semibold mb-4 text-gray-700">Permissions</h3>
            <label className="flex items-center space-x-3 cursor-pointer p-3 bg-white rounded shadow-sm border border-gray-200 hover:border-blue-400 transition-all">
              <input
                type="checkbox"
                checked={isFullAccess}
                onChange={(e) => setIsFullAccess(e.target.checked)}
                className="h-5 w-5 text-blue-600 rounded"
              />
              <div>
                <span className="text-gray-800 font-bold block">Full Transaction Access</span>
                <span className="text-xs text-gray-500">Allow view and management of all transaction records</span>
              </div>
            </label>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end space-x-2 p-5 border-t bg-gray-50 rounded-b-lg">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded border-none cursor-pointer transition-colors font-medium"
          >
            Cancel
          </button>
          <button
            onClick={() => onSave(isFullAccess)}
            className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded border-none cursor-pointer transition-colors font-medium"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransactionAccessAddEditModal;